import React from "react";
import { ArticleCard } from "./ArticleCard";
import Grid from "./Grid";

export const AccessoryList = ({ accessories, category }) => {
  return (
    <Grid as="ul" equalHeight>
      {accessories
        .sort(function (a, b) {
          return a.menuOrder - b.menuOrder;
        })
        .map((item) => {
          const accessory = item.accessory;
          let featuredImageData;

          // Select either the featured, the first one in gallery
          if (accessory.featuredImage) {
            featuredImageData = accessory.featuredImage.node.mediaItemUrl;
          } else if (
            accessory.productData?.productGallery &&
            accessory.productData.productGallery.length > 1
          ) {
            featuredImageData = accessory.productData.productGallery[0].mediaItemUrl;
          }

          return (
            <Grid item as="li" sm="6" md="4" lg="3" key={accessory.id}>
              <ArticleCard
                url={accessory.uri}
                title={accessory.title}
                featuredImage={featuredImageData}
                product="true"
                category={category}
              />
            </Grid>
          );
        })}
    </Grid>
  );
};
